// This contains a mapping of the supported countries and their respective locales
export const supportedCountriesWithoutLocale = {
  AW: 'NL',
  BQ: 'NL',
  CW: 'NL',
  SX: 'NL',
};
